import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';

const ConfirmDialog = ({
  showDialog,
  message,
  onConfirm,
  onClose,
  title = 'Confirmação',
  confirmLabel = 'Confirmar',
  confirmColor = 'primary',
}) => {
  if (!showDialog) {
    return null;
  }

  const handleConfirm = async () => {
    try {
      await onConfirm(); // Await the promise
      onClose(); // Close dialog after confirmation
    } catch (error) {
      console.error("Error in confirm action:", error);
      // Optionally show error in Snackbar (requires context access)
    }
  };

  return (
    <Dialog open={showDialog} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="outlined">
          Cancelar
        </Button>
        <Button onClick={handleConfirm} color={confirmColor} variant="contained" autoFocus>
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
